import React, { useState, useEffect, useContext }  from 'react'
import './sidebar.css'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClockRotateLeft, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'


const  Sidebar=() => {
const { setProfile, profile, token,setToken } = useContext(ShareContext)
  var username=Constants.isServerEnv? Constants.getCookie("profilename"):'seniolaecfo' ; //seniola1  //  //jsanni  //
  
  var url=`${Constants.apiUrl}/gazette/links/${username}`
  const [isLoading,setIsLoading]= useState(false);
  const [links, setLinks]=useState([]);
  const [active, setActive]=useState(-1);

  useEffect(() => {
    const username_lc=localStorage.getItem("token");
    
    
    if(token==null && username_lc==null){
      onLoad();
    }else if(token==null && username_lc!=null){
      setToken(username_lc);
      const pp=localStorage.getItem("profile");
      setProfile(JSON.parse(pp));
    }
    
    
   
  }, [username]);

const onRealLink=(lnk)=>{
  let result = lnk.replace("~", Constants.primarySite );
  return result;
}
  const onLoad= async()=>{
    //for account registration
  //  console.log(`the calling url ${url}`);
    try {
        setIsLoading(true);
        const resp = await fetch(url, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
        });
        
        const data = await resp.json();
      
        setIsLoading(false);
      //  console.log(data);
        if (data.code === 0) {
         // console.log('Process resources');
         var aa= fromResources(data.resources, data.allparent);
          setLinks(Object.values(aa)); 
          var ids={...data.pro, role:data.role, username};
          console.log(ids);
          setProfile(ids);
          //store in local storage
         const str= JSON.stringify(ids);
         localStorage.setItem('profile',str);
         
        }else {    
            alert(data.status);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        
      }
}

const fromResources=(directlink, parents)=>{
  var item={}
  var setItem=new Set();
  //load all parent
  for(const x of parents){
      item[x.resourceId]={...x,inner:[]};
  }

  for(const x of directlink){
    if(x.parentId==0){
      var aa=item[x.resourceId];
      if(aa==null){
        item[x.resourceId]={...x,inner:[]};
      }
    }
  }

  for(const x of directlink){
  //   {
  //     "resourceId": 4,
  //     "parentId": 2,
  //     "resourceName": "Case Documents",
  //     "resourceUrl": "~/CMS/CaseDocuments.aspx",
  //     "isActive": true,
  //     "createdBy": null,
  //     "createdOn": null,
  //     "rank": 0,
  //     "roleResourceMappings": [],
  //     "userResourceMappings": []
  // }
  //var parent = parents.filter((c) => c.resourceId ==x.parentId);

  var maing=item[x.parentId];
        if(maing==null){
        //  console.log('main is null');
        //  console.log(x);
          //console.log(maing);
        }else{
          var inner= [...maing.inner,x];      
        item[x.parentId]={...maing,inner};
        }
         
    
  }

  //console.log('final items constructed')
  //console.log(item);
  return item;

}

  return (
    <div className='sidebar'>
        <nav className="sidebar-links">
            <ul>
            <li><Link to="/home/dashboard">Dashboard</Link></li>
            
                {links.length>0 && links.map((item, id) => { return (
                  <>
                            <li key={id} onClick={()=> setActive(id)}> {item.inner.length>0 && <strong>  <FontAwesomeIcon icon={faChevronDown} /> </strong>}
                            {item.resourceUrl==''?item.resourceName:<a href={onRealLink(item.resourceUrl)}>{item.resourceName}</a>}
                            </li>
                           {active==id && <ul className='sub'>
                              {item.inner.length>0 && item.inner.map((inn, idx) => { return (
                              <li key={idx}><a href={onRealLink(inn.resourceUrl)}>{inn.resourceName}</a> </li>
                                
                          )})}
                         
                          
                            </ul>} 
                             
                            </>
                        )})}
                        { profile.role=='LegalCounsel' && <>
                        <li><Link to="/upload/documents">Upload Documents</Link></li>
                        </>}

                        {(profile.role=='CommissionerForOaths' || profile.role=='e-CFO'|| profile.role=='e-Commissioner for Oaths' ||  profile.role=='LegalCounsel' || profile.role=='ACR' || profile.role=='e-ACR') && <>
                        
             {/*  <li><Link to="/upload/e-swearing">e-Swearing</Link></li> */}
              <li><Link to="/cfo/appointments">Appointments</Link></li>
              <li><Link to="/upload/e-swearing">Case Documents</Link></li>
           {/*    <li><Link to="/upload/e-swearing">Affidavit Documents</Link></li> */}
              <li><Link to="/templates/AffidavitDocuments">Affidavits Documents</Link></li>
                        </>}
              
              {profile.role=='Customer' && <>
                <li><Link to="/templates/AffidavitDocuments">Affidavits Documents</Link></li>
              </>}

              {(profile.role=='e-DM' || profile.role=='ACR' || profile.role=='e-ACR') && <>
              <li><Link to="/templates/affidafits">Affidavits Templates</Link></li>
              <li><Link to="/templates/AffidavitDocuments">Affidavits Documents</Link></li>
              <li><Link to="/templates/document">Document Templates</Link></li>
              <li><Link to="/templates/placeholders">Placeholders</Link></li>

              <li><Link to="/setting">Settings</Link></li>
              <li><Link to="/mapgazette/1">Map Litigation Gazette</Link></li>
              </>}
              
              
              
              <li><Link to="/payment-record"> Payment History</Link></li> 
              
              <li><Link to="/profile">Profile</Link></li>
              
            </ul>
        </nav>
    </div>
  )
}

export default Sidebar